export const portalText = {
  en: {
    header: {
      year: "Chaturmasya 2026",
      title: "Sacred 60-Day Sojourn",
      committee: "Committee",
    },

    tabs: {
      schedule: "Schedule",
      seva: "Seva",
    },

    start: "Start",
    end: "End",

    weekly: {
      everyMonday: "Every Monday",
      title: "Rudrabhisheka",
      subtitle: "Morning · Contact office",
    },

    footer: {
      booking: "Contact office for bookings & timings",
      call: "Call",
    },

    committee: {
      title: "Organizing Committee",
      core: "Core Members",
      sub: "Sub-Committees",
    },
  },

  kn: {
    header: {
      year: "ಚಾತುರ್ಮಾಸ್ಯ 2026",
      title: "ಪವಿತ್ರ 60 ದಿನಗಳ ಚಾತುರ್ಮಾಸ್ಯ",
      committee: "ಸಮಿತಿ",
    },

    tabs: {
      schedule: "ವೇಳಾಪಟ್ಟಿ",
      seva: "ಸೇವೆಗಳು",
    },

    start: "ಆರಂಭ",
    end: "ಸಮಾಪ್ತಿ",

    weekly: {
      everyMonday: "ಪ್ರತಿ ಸೋಮವಾರ",
      title: "ರುದ್ರಾಭಿಷೇಕ",
      subtitle: "ಬೆಳಗ್ಗೆ · ಕಚೇರಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ",
    },

    footer: {
      booking: "ಬುಕಿಂಗ್ ಮತ್ತು ಸಮಯಗಳಿಗಾಗಿ ಕಚೇರಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ",
      call: "ಕರೆ ಮಾಡಿ",
    },

    committee: {
      title: "ಆಯೋಜನಾ ಸಮಿತಿ",
      core: "ಮುಖ್ಯ ಸದಸ್ಯರು",
      sub: "ಉಪ ಸಮಿತಿಗಳು",
    },
  },
};